module.exports = __webpack_public_path__ + "img/deyang.bda3dfea.jpg";